module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "/user/userTrackList"
    }
  }, [_vm._v("学员跟踪记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("添加跟踪记录-报名失败记录")])], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.uid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "uid", _vm._n($$v))
      },
      expression: "formValidate.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nickname", $$v)
      },
      expression: "formValidate.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "adviserName", $$v)
      },
      expression: "formValidate.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "studyAdviserName", $$v)
      },
      expression: "formValidate.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('div', [_vm._v(" ")]), _vm._v(" "), _c('div', [_vm._v("报名失败原因：")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.teacherReason),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "teacherReason", $$v)
      },
      expression: "formValidate.teacherReason"
    }
  }, [_vm._v("老师原因")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.equipmentReason),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "equipmentReason", $$v)
      },
      expression: "formValidate.equipmentReason"
    }
  }, [_vm._v("设备原因")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.netReason),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "netReason", $$v)
      },
      expression: "formValidate.netReason"
    }
  }, [_vm._v("网络原因")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.highPrice),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "highPrice", $$v)
      },
      expression: "formValidate.highPrice"
    }
  }, [_vm._v("价格偏高")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.registerOtherAgencies),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "registerOtherAgencies", $$v)
      },
      expression: "formValidate.registerOtherAgencies"
    }
  }, [_vm._v("已报名其它机构")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.likeShortTermCourse),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "likeShortTermCourse", $$v)
      },
      expression: "formValidate.likeShortTermCourse"
    }
  }, [_vm._v("意向短期课程")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.contrastiveCompetition),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "contrastiveCompetition", $$v)
      },
      expression: "formValidate.contrastiveCompetition"
    }
  }, [_vm._v("对比竞品")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.inThinking),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "inThinking", $$v)
      },
      expression: "formValidate.inThinking"
    }
  }, [_vm._v("考虑中")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.childNotCooperate),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "childNotCooperate", $$v)
      },
      expression: "formValidate.childNotCooperate"
    }
  }, [_vm._v("孩子不配合")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.worryEffect),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "worryEffect", $$v)
      },
      expression: "formValidate.worryEffect"
    }
  }, [_vm._v("担心效果")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "true-value": "1",
      "false-value": "0"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.lossOfUnion),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "lossOfUnion", $$v)
      },
      expression: "formValidate.lossOfUnion"
    }
  }, [_vm._v("学员失联")]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "placeholder": "其它/备注"
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formValidate.specialRemark),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "specialRemark", $$v)
      },
      expression: "formValidate.specialRemark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 9
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期",
      "prop": "nextHandlerTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value": _vm.formValidate.nextHandlerTime
    },
    on: {
      "on-change": _vm.nextTimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 7
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系人",
      "prop": "nextHandlerId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.formValidate.nextHandlerId),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nextHandlerId", _vm._n($$v))
      },
      expression: "formValidate.nextHandlerId"
    }
  }, _vm._l((_vm.nextHandler), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "operateStatus"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formValidate.operateStatus),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "operateStatus", $$v)
      },
      expression: "formValidate.operateStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未处理")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已处理")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit()
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf063054","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/AddOrderFailRecords.vue
// module id = 1976
// module chunks = 8